import { render, staticRenderFns } from "./activity-category-table.vue?vue&type=template&id=9a12caae&scoped=true&"
import script from "./activity-category-table.ts?vue&type=script&lang=ts&"
export * from "./activity-category-table.ts?vue&type=script&lang=ts&"
import style0 from "./activity-category-table.scss?vue&type=style&index=0&id=9a12caae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a12caae",
  null
  
)

export default component.exports